export default __webpack_public_path__ + "static/media/fpb30000.2b108e10.png";